import { z } from "zod";
import { optionalEnum } from "./_helpers/optional";

const PostHogContextSchema = z
  .object({
    distinct_id: z.string().optional().describe("PostHog Distinct Id"),
    session_id: z.string().optional().describe("PostHog Session Id"),
    device_id: z.string().optional().describe("PostHog Device Id"),
  })
  .partial()
  .describe("PostHog Context");

export const LeadInsertSchema = z.object({
  email: z.string().email().describe("Email"),
  metadata: z.record(z.unknown()).optional().describe("Metadata"),
  posthog: PostHogContextSchema.optional().describe("PostHog Context"),
});

export type LeadInsert = z.infer<typeof LeadInsertSchema>;

export const LeadQualifySchema = z.object({
  email: z.string().email().describe("Email"),
  name: z.string().min(2).optional().describe("Name"),
  team_size: optionalEnum(["1-9", "10-49", "50-200", "200+"] as const).describe(
    "Team Size",
  ),
  industry: z.string().optional().describe("Industry"),
  posthog: PostHogContextSchema.optional().describe("PostHog Context"),
});

export type LeadQualify = z.infer<typeof LeadQualifySchema>;
